// hooks/usePagination.js
import { useState } from 'react';

const usePagination = (initialLimit = 10) => {
    const [currentParams, setCurrentParams] = useState({ limit: initialLimit, page: 0 });
    const [totalItems, setTotalItems] = useState(0);

    const resetPage = () => {
        setCurrentParams(prev => ({ ...prev, page: 0 }));
    };

    const setPage = (page) => {
        setCurrentParams(prev => ({ ...prev, page }));
    };

    const setLimit = (limit) => {
        setCurrentParams(prev => ({ ...prev, limit, page: 0 }));
    };

    return {
        currentParams,
        setCurrentParams,
        totalItems,
        setTotalItems,
        resetPage,
        setPage,
        setLimit,
        page: currentParams.page,
        limit: currentParams.limit
    };
};

export default usePagination;